module.exports = __webpack_public_path__ + "static/bg (12)-f016af5d752593bae24221022d2a6a1f.jpg";